// Componente de pedidos preparados hoy
// Orders prepared today component
import { SectionBox } from '@shared/components/ui/SectionBox';
import { useTranslation } from 'react-i18next';
import { useOrdersKpis } from '../../hooks/useOrdersKpis';

interface OrdersPreparedTodayProps {
  filters?: {
    shop_id?: number;
    cutoff_time?: string;
    date?: string;
  };
}

export const OrdersPreparedToday = ({ filters = {} }: OrdersPreparedTodayProps) => {
  const { t } = useTranslation('homeModule');
  const { ordersKpis, isLoading } = useOrdersKpis(filters);

  // Calcular total de pedidos (sin incluir "Por confirmar")
  // Solo se cuentan: Preparados, Por preparar y En preparación
  const totalOrders = ordersKpis.sent + ordersKpis.pending + ordersKpis.preparing;
  // Pedidos preparados hoy = Solo los que están en estado "Preparados"
  const preparedToday = ordersKpis.sent;
  // Calcular porcentaje basado en los pedidos preparados hoy
  const progressPercentage = totalOrders > 0 ? (preparedToday / totalOrders) * 100 : 0;

  if (isLoading) {
    return null;
  }

  return (
    <SectionBox className="bg-card-bg" data-testid="orders-prepared-today">
      <h3 className="font-medium mb-3 text-sm">{t('order_status.prepared_today.title')}</h3>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-complementary-text">
            {preparedToday} de {totalOrders} {t('common.orders')}
          </span>
          <span className="text-sm font-bold">{progressPercentage.toFixed(2)}%</span>
        </div>

        {/* Barra de progreso */}
        <div className="w-full bg-card-border rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </SectionBox>
  );
};
